import { CONSULTATIONS_ENDPOINTS } from '../../../utils/api/endpoints/consultationsEndpoints';
import { ConsultationSummaryENTResponse } from './useConsultationSummaryENT.types';

const PREFIX = '[consultationSummaryENTQuery]';

export const queryConsultationSummaryENT = async (consultationId: number) => {
  console.log(PREFIX, `Fetching consultation #${consultationId}...`);
  const response = await CONSULTATIONS_ENDPOINTS.consultationSummaryENT(consultationId);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received consultation #${consultationId}.`);
  return json as ConsultationSummaryENTResponse;
};
